<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="externalId">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="distributionReference">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'issuedAfter'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'issuedBefore'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'expiresAfter'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'expiresBefore'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-single-select-search-control initialDefaultValue="current">
                    <wbo-select-options>
                        <wbo-select-option value="all" label="wbo.deal.option.status.all">
                        </wbo-select-option>
                        <wbo-select-option value="current" label="wbo.deal.option.status.current">
                        </wbo-select-option>
                        <wbo-select-option value="expired" label="wbo.deal.option.status.expired">
                        </wbo-select-option>
                        <wbo-select-option value="discontinued" label="wbo.deal.option.status.discontinued">
                        </wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column [allowDescendingSorting]="false" field="distributionReference"></wbo-main-search-column>
        <wbo-column [allowDescendingSorting]="false" field="externalId"></wbo-column>
        <wbo-column [sortable]="false" field="distributionType"></wbo-column>
        <wbo-date-column [allowDescendingSorting]="false" field="issueDate"></wbo-date-column>
        <wbo-date-column [allowDescendingSorting]="false" field="expiryDate"></wbo-date-column>
        <wbo-column field="displayStatus" [sortable]="false"></wbo-column>
        <wbo-column field="usage" [sortable]="false"></wbo-column>
        <wbo-actions-search-column>
            <wbo-discontinue-search-action></wbo-discontinue-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
